// removed by extract-text-webpack-plugin
module.exports = {"wolf":"#dcdee2","this":"ActivitiesClassView__this___2N7U3","content":"ActivitiesClassView__content___ovOq5"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/ActivitiesClassView.css
// module id = 2697
// module chunks = 0 1